export enum UserRole {
  ACCOUNT_MEMBER = 'ACCOUNT_MEMBER',
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  TEAM_OWNER = 'TEAM_OWNER',
  TEAM_MEMBER = 'TEAM_MEMBER',
}

export type AwsRole = {
  id: string;
  name: string;
};

export type AWSAccountDetail = {
  owner: string;
  id: string;
  description: string;
  awsRoles: AwsRole[];
};

export type awsAccount = {
  awsAccountId: string;
  roles: UserRole[];
  awsRoles: AwsRole[];
  awsAccountDetail: AWSAccountDetail;
  prod: boolean;
  catalogTestAccount: boolean;
  onboarded: boolean;
  regions: string[];
};

export enum actionEnum {
  ADD_USER = 'ADD_USER',
  CREATE_TEAM = 'CREATE_TEAMS',
  UPDATE_TEAM = 'UPDATE_TEAMS',
  DELETE_USER = 'DELETE_USER',
  DELETE_TEAM = 'DELETE_TEAM',
  REASSIGN_USERS = 'REASSIGN_USERS',
  ADD_TEAM_MEMBERS = 'ADD_TEAM_MEMBERS',
  GRANT_PERMISSION = 'GRANT_PERMISSION',
  REVOKE_PERMISSION = 'REVOKE_PERMISSION',
  UPDATE_PERMISSION = 'UPDATE_PERMISSION',
  ADD_PERMISSION = 'ADD_PERMISSION',
  REMOVE_PERMISSION = 'REMOVE_PERMISSION',
}

export type permissionDto = {
  awsRoleRequests?: AWSRoleRequest[];
  instance?: string;
  roles?: string[];
};
export type CreateOrUpdateTeamDto = {
  currentTeam: {
    name?: string;
    manager?: string;
    owner?: string;
  };
  updatedTeam?: {
    name: string;
    manager?: string;
  };
};
export type ToolPermissions = {
  tool: string;
  permissions: permissionDto[];
};

export type activityDto = {
  performedOn?: string;
  toolPermissions?: ToolPermissions;
  teamMembers?: AssignMember[];
  teamDetails?: CreateOrUpdateTeamDto[];
};

export type AuditLogsDto = {
  currentUser: string | undefined;
  action: actionEnum;
  activities?: activityDto[] | void[];
  actionDate: string;
  currentTeam?: string;
};

export type InstanceName = {
  instanceName: string | null;
};

export type UserId = {
  userId: string;
};

export type AwsAccountId = {
  awsAccountId: string;
};

export type BlueBoxAwsAccountDto = {
  accountId: string;
  mbId: string;
  mbIdPair: string;
  stage: string;
  orgName: string;
  teamName: string;
  blockedPlugins: string[];
  teamDomain: string[];
  cloudEngineVersion: string;
  platformSubtype?: string;
};

export type BlueBoxValidateSecretDto = {
  mbAccountName: string;
  awsAccountId: string;
  secretName: string;
  mbIdPair: string;
};

export type BlueBoxValidateSecretResponseDto = {
  secretExists: boolean;
};

export type InstallCatalogPluginDto = {
  awsAccountId: string;
  productName: string;
  leanIx: string;
  pluginId: string;
  config: string;
  userId: string;
  pluginVersion: string[];
  namespace?: string;
  realTimeLogs?: boolean;
  region?: string;
  dryRun?: boolean;
};

export type SavePluginConfigDraftRequestDto = {
  awsAccountId: string;
  pluginId: string;
  region?: string;
  productName?: string;
  leanIx?: string;
  config: string;
  userId: string;
  pluginVersion: string;
  namespace?: string;
  realTimeLogs?: boolean;
};

export type PluginConfigDraftResponseDto = {
  id?: string;
  awsAccountId: string;
  pluginId: string;
  region?: string;
  productName?: string;
  leanIx?: string;
  config: string;
  userId: string;
  pluginVersion: string;
  namespace?: string;
  realTimeLogs?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type TeamId = {
  teamId: string;
};

export type WiwId = {
  wiwId: string;
};

export type UserDto = {
  id?: string | undefined;
  awsAccounts?: awsAccount[];
};

export type WiwIdDto = {
  id: string;
  givenName: string;
  surname: string;
};

export type LeanIxTeamDto = {
  id: string;
  name: string;
  leanIxId: string;
  mbgAppShortName: string;
  description: string;
  release: string;
};

export type TeamDto = {
  id: string;
  name: string;
  manager?: string;
  owner: string;
  oldTeam?: string;
  oldManager?: string;
};

export type ToolDto = {
  id: string;
  name: string;
};

export type TeamUserRole = {
  team: TeamDto;
  teamRole: string;
};

export type TeamsDto = {
  teams: TeamDto[];
};

export type CreateTeamsDto = {
  teams: CreateTeamDto[];
};

export type AssignMemberDTO = {
  id: string;
  teamRole: string;
  teams: string[];
};

export type AssignMember = {
  id?: string;
  teamRole?: string;
  teams?: string[];
  reAssignedTeamNames?: string[];
  teamNames?: string[];
};

export type AWSRoleRequest = {
  awsAccountId: string;
  awsRoleIds: string[];
  awsAccountRoleId: string;
  awsSelectedRoles: string[];
  awsInstance: string;
  awsExistingRoles: string[];
};

export type CreateAccess = {
  id: string;
  awsRoleRequests: AWSRoleRequest[];
};

export type UpdateAccess = {
  awsRoleRequests: AWSRoleRequest[];
};

export type DeleteAccess = {
  awsAccountIds: AWSDeleteAccessRequest[];
};

export type AWSDeleteAccessRequest = {
  awsAccountId: string;
  awsInstance: string;
};

export type CreateAccessDTO = {
  status: string;
};

export type UpdateAccessDTO = {
  status: string;
};
export type RemoveAccessDTO = {
  status: string;
};

export type RemoveMemberDTO = {
  status: string;
};

export type ReassignTeamMembersDTO = {
  status: string;
};

export type RemoveTeamDTO = {
  status: string;
};

export type AssignMembers = {
  members: AssignMember[];
  teamName?: string;
};

export type AssignMembersDTO = {
  members: AssignMember[];
};

export type CreateTeamDto = {
  name: string;
  owner: string;
  manager?: string;
};

export type AwsAccountUser = {
  id: string;
  email?: string;
  firstName: string;
  surname: string;
};

export type TeamUser = {
  id?: string;
  name?: string;
  role?: string;
  team?: string[];
  wiwId?: string;
  teams?: TeamUserRole[];
  [key: string]: any;
};

export type TeamMemberName = {
  givenName: string;
  surname: string;
};

// SonarQube
export type Group = {
  id: string;
  name: string;
  membersCount: number;
  default: boolean;
};

export type Paging = {
  pageIndex: number;
  pageSize: number;
  total: number;
};

export type SearchUserGroupsResponse = {
  paging: Paging;
  groups: Group[];
};

export interface InstanceUsers {
  instanceName: string;
  users: UserInfo[];
}

export interface UserInfo {
  login: string;
  name: string;
  active: boolean;
  groups: string[];
  tokensCount: number;
  local: boolean;
  externalIdentity: string;
  externalProvider: string;
  lastConnectionDate: string;
}

export interface MultiUserGroupRequest {
  instanceName?: string;
  groups: string[];
  loginName: string;
}

export interface UserGroupResponse {
  success: boolean;
  error?: string;
}

export interface SearchPermissionTemplatesResponse {
  permissionTemplates: PermissionTemplate[];
}

export interface PermissionTemplate {
  id: string;
  name: string;
  projectKeyPattern: string;
  createdAt: string;
  updatedAt: string;
  permissions: Permission[];
}

interface Permission {
  key: string;
  usersCount: number;
  groupsCount: number;
  withProjectCreator: boolean;
}

export interface GroupPermission {
  name: string;
  permissions: PermissionList[];
}

export type SonarUserGroupsDto = {
  users: SonarUser[];
};

export type TeamInfo = {
  team: Team;
  ownerId: string;
  teamMember: Team;
};

export type Team = {
  name: string;
  id: string;
  teamRole: string;
};

export type SonarUser = {
  name: string;
  groups: string[];
  instanceName: string;
  users: any;
};

export type PermissionList =
  | 'admin'
  | 'codeviewer'
  | 'issueadmin'
  | 'securityhotspotadmin'
  | 'scan'
  | 'user';

// Jenkins
export type JenkinsUserGroupsDto = {
  users: JenkinsUser[];
};

export type JenkinsUser = {
  instanceName: string;
  projectRoles: string[];
};

export type MultiGitHubUserGroupClusterRequest = MultiGitHubUserGroupRequest & {
  teamId: string;
  userGroupType: string;
};

export type MultiGitHubUserGroupRequest = {
  organization: string;
  groups: string[];
  loginName: string;
};

export type GitHubUserOrganizationTeam = {
  data: {
    organization: {
      teams: {
        edges: {
          node: {
            name: string;
          };
        }[];
      };
    };
  };
};

export type PluginDto = {
  id: string;
  pluginName: string;
  pluginDescription: string;
  billable: boolean;
  price?: number;
  pluginDocumentLink: string;
  mandatory: boolean;
  raiseRequestLink: string;
  buttonRaiseRequest: string;
  version?: string;
  active: boolean;
  multiInstance: boolean;
  paymentInfo: string | null;
  paymentType: string | null;
  tags?: string[];
  maintenanceEnabled: boolean;
  operationsBlocked?: boolean;
};

export type PlayListDto = {
  id: string;
  name: string;
  description: string;
  documentLink: string;
};

export type PluginsAndPlayListsDto = {
  plugins: PluginDto[];
  playlists: PlayListDto[];
};

export type UpdateDto = {
  available: boolean;
  version: string;
};

export type InstalledPluginDto = {
  id: string;
  accountId: string;
  pluginName: string;
  version: string;
  buildId: string;
  buildStatus: string;
  requestedOn: string;
  updatedOn: string;
  billable: boolean;
  eventId: string;
  productName: string;
  leanIx: string;
  config: string;
  pluginId: string;
  mandatory: boolean;
  type: string;
  namespace: string;
  multiInstance: boolean;
  update: UpdateDto;
  repoId: string;
  supportLink: string;
  serviceNowLink: string;
  changeLogLink: string;
  documentationLink: string;
  realTimeLogs: boolean;
  pluginUrl: string;
  maintenanceEnabled: boolean;
  operationsBlocked?: boolean;
};

export type InstalledPluginsDTO = {
  pluginRequests: InstalledPluginDto[];
};

export type HeliosCoreKmsRoleCheckDto = {
  awsAccountId: string;
  region: string;
};

export type HeliosCoreKmsRoleCheckResponseDto = {
  roleExists: boolean;
};

export enum UserGroupType {
  Internal = 'internal',
  External = 'external',
}

export enum UserType {
  Daimler = 'daimler',
  Supplier = 'supplier',
}

export type PluginCheckLogDto = {
  pluginLogs: string;
  pluginLogUrl: string;
};

export type TransitService = {
  id: string;
  name: string;
  stage: string;
  defaultService: boolean;
  mandatory: boolean;
};

export type AwsAccountProjectDto = {
  projectInfo: ProjectInfo;
  additionalInfo: AdditionalInfo;
  platformSubtype: string;
  bearerToken: string;
  gdprCompliant: boolean;
  termsAndConditions: boolean;
  user: string;
};

export type ProjectInfo = {
  orgName: string;
  stage: string;
  teamName: string;
  awsOrgId: string;
  e4MailId: string;
  projectName: string;
  name: string;
  email: string;
  deputyIds: string[];
  costCenter: string;
  costCenterPlantId: string;
  coElement: string;
  csrIds: string[];
  awsorgId: string;
  offeringName: string;
  leanixId: string;
};

export type AdditionalInfo = {
  orgName: string;
  stage: string;
  teamName: string;
  e4Email: string;
  leanixId: string;
};

export type AccountRequestDto = {
  projectId: string;
  projectStatus: string;
  accountId: string;
  stage: string;
  accountStatus: string;
  errorMessage: string | null;
};

export type AccountRequestConfig = {
  awsOrgId: string;
  platformSubtype: string;
};

export type Regions = {
  regions: string[];
};

export type FirewallDomains = {
  domain: string;
  ports: string[];
};

export type MattermostValidateUsernameDto = {
  valid: boolean;
  message: string;
};

// ──────────────────────────────────────────────
// PLAYLISTS
// ──────────────────────────────────────────────

export type CatalogPlaylistPluginDto = {
  pluginName: string;
  pluginId: string;
  orderIndex: number;
  scope: string | null;
  multiInstance: boolean | null;
  docs?: string | null;
  latestVersion?: string | null;
  description?: string | null;
};

export type CatalogPlaylistDto = {
  id: string;
  name: string;
  description: string;
  documentLink: string;
  creator: string;
  region: string;
  active: boolean;
  plugins: CatalogPlaylistPluginDto[];
};

export type PlaylistExecutionStatus =
  | 'DRAFT'
  | 'IN_PROGRESS'
  | 'PAUSED'
  | 'FAILED'
  | 'COMPLETED'
  | 'UNINSTALLING'
  | 'UNINSTALLED'
  | 'DISCARDED';

export type PlaylistExecutionItemStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'SUCCEEDED'
  | 'FAILED'
  | 'SKIPPED'
  | 'CANCELLED';

export type PlaylistExecutionItemDto = {
  id: string;
  pluginName: string;
  pluginId: string;
  orderIndex: number;
  status: PlaylistExecutionItemStatus;
  operationType: string | null;
  resolvedVersion: string | null;
  config: string | null;
  configSchema: string | null;
  billable: boolean | null;
  leanIxId: string | null;
};

export type PlaylistExecutionDto = {
  id: string;
  playlistId: string;
  playlistName: string;
  awsAccountId: string;
  status: PlaylistExecutionStatus;
  currentIndex: number;
  createdBy: string;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  items: PlaylistExecutionItemDto[];
};

export type CreatePlaylistExecutionDto = {
  playlistId: string;
  awsAccountId: string;
};

export type PlaylistExecutionItemConfigDto = {
  itemId: string;
  config?: string;
  leanIxId?: string;
};

export type PlaylistExecutionConfigDto = {
  items: PlaylistExecutionItemConfigDto[];
};

export type PlaylistResumeRequestDto = {
  fromIndex?: number;
};

export type PlaylistUninstallRequestDto = {
  excludePluginIds?: string[];
};
